var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{class:[_vm.direction, { moved: _vm.moved }],attrs:{"src":require("@/assets/images/flag.svg"),"alt":"flag"},on:{"mouseover":_vm.togglePosition,"click":_vm.togglePosition}})
}
var staticRenderFns = []

export { render, staticRenderFns }